module.exports = __webpack_public_path__ + "img/icone_documents.62f19c8a.svg";